import api from './axios'

/**
 * Chat Submissions API
 * For listing saved chat conversation submissions
 */
export const chatSubmissionsApi = {
    /**
     * Get chat submissions list with filters
     */
    getAll: async (filters = {}) => {
        const params = new URLSearchParams()

        if (filters.status) params.append('status', filters.status)
        if (filters.search) params.append('search', filters.search)
        if (filters.page) params.append('page', filters.page)
        if (filters.perPage) params.append('per_page', filters.perPage)

        const response = await api.get(`/chat-submissions?${params.toString()}`)
        return response
    },

    /**
     * Get stats for chat submissions
     */
    getStats: async () => {
        const response = await api.get('/chat-submissions/stats')
        return response
    },
}

export default chatSubmissionsApi
